import { toast } from '@app/components/ui/Toast/toast'
import { queryClient } from '@app/config/queryClient'
import { upsertLayerSuitability } from '@app/domains/suitability/services/suitability.service'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { UpdateLayerSuitabilityPayload } from '../types'

export const useUpsertLayerSuitability = (layerId: string) => {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: ({
      useCaseSlug,
      payload,
    }: {
      useCaseSlug: string
      payload: UpdateLayerSuitabilityPayload
    }) => upsertLayerSuitability(layerId, useCaseSlug, payload),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['layer-suitability', layerId] })
      toast({ title: 'Suitability updated', type: 'success', position: 'top-center' })
      navigate(-1)
    },
    onError: () => {
      toast({ title: 'Failed to update suitability', type: 'error', position: 'top-center' })
    },
  })
}
